import * as actions from '../../redux/actions';
import * as homeActions from '../../../home/redux/actions';

import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const initialState = {
	name: null,
	nameError: null,
	email: null,
	emailError: null,
	phone: null,
	phoneError: null,
	comment: null,
	commentError: null,
};

const ThemeFiveContactForm = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const [state, setState] = useState(initialState);

	const onChange = (value, type) => {
		if (type == 'phone') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.phone) {
			setState({ ...state, phoneError: true, phoneErrorMessage: 'Ingresa tu número de teléfono' });
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.comment) {
			setState({
				...state,
				commentError: true,
				commentErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};
	const onSubmit = () => {
		if (!validate()) {
			return;
		}
		if ((operator.operator_name === 'tepual' || operator.operator_name === 'expressonorte' || operator.operator_name === 'bahiaazul' || operator.operator_name === 'erbuc' || operator.operator_name === 'trrass' || operator.operator_name === 'jeldres')) {


			let data = {
				name: state.name,
				last_name: null,
				email: state.email,
				phone_number: state.phone,
				comments: state.comment,
				operator_id: operator.operator_id,
				operator_name: operator.operator_name,
			};
			props.actions
				.apiCall({
					url: AppData.BASE_URL + 'api/opsite_contact_info',
					method: 'POST',
					data,
				})
				.then(
					res => onContactInfoResponse(res),
					err => onContactInfoResponse(err),
				);
		}
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		<div className="themes-theme-five-contact-form new-container ">
			<div className="contact">
				<div className="contact-header">
					<style>
						.themes-theme-five-contact-form .contact-header{'{'}
						background:
						{operator &&
							operator.operator_name === 'erbuc' &&
							operator.color_codes &&
							operator.color_codes.sub_header_color
							? operator.color_codes.sub_header_color
							: operator.color_codes.secondary_color}
						{'}'}
					</style>
					<div
						className="contact-header-text font13"
						style={{
							borderBottom: `2px solid ${operator.color_codes.tertiary_color}`,
						}}
					>
						CONTÁCTANOS
					</div>
				</div>
				<div className="contact-bottom">
					<div className="align-contact-inputs">
						<div className="contact-input-item">
							<div className="contact-input-label font11">Nombre</div>
							<KuposInput
								type="text"
								placeholder="Nombre"
								value={state.name}
								error={state.nameError}
								errorMessage={state.nameErrorMessage}
								onChange={val => onChange(val, 'name')}
							/>
						</div>

						<div className="contact-input-item">
							<div className="contact-input-label font12">Teléfono</div>
							<KuposInput
								type="number"
								placeholder="Teléfono"
								value={state.phone}
								error={state.phoneError}
								errorMessage={state.phoneErrorMessage}
								onChange={val => onChange(val, 'phone')}
							/>
						</div>

						<div className="contact-input-item">
							<div className="contact-input-label font12">Email</div>
							<KuposInput
								type="email"
								placeholder="Email"
								value={state.email}
								error={state.emailError}
								errorMessage={state.emailErrorMessage}
								onChange={val => onChange(val, 'email')}
							/>
						</div>
					</div>

					<div className="text-area-input">
						<div className="contact-input-label font12">Mensaje</div>
						<textarea
							className="text-area font12"
							rows={6}
							placeholder="Mensaje"
							onChange={e => onChange(e.target.value, 'comment')}
						/>
						<span className="error font8">
							{state.commentError ? state.commentErrroMessage : null}{' '}
						</span>
					</div>

					<div className="contact-button ">
						<KuposButton
							operator={operator}
							className="px-45 "
							onClick={() => {
								onSubmit();
							}}
						>
							ENVIAR
						</KuposButton>
					</div>
				</div>
			</div>
			<KuposErrorSuccessModal
				success={state.status == 200 ? true : false}
				showModal={state.showModal}
				onButtonClick={() => {
					setState({ showModal: false });
					window.location.reload();
				}}
				bodyText={state.responseMessage}
			/>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFiveContactForm);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/components/ThemeFiveContactForm.js